module.exports = [
  'contactListService',
  '$translate',
  '$ionicScrollDelegate',
  '$utils',
  function (contactListService, $translate, $ionicScrollDelegate, $utils) {
    /** 根据类型转换成对应的头像图标 */
    /** avatar according to the type */
    const avatarType = {
      'D': 'icon-icongroup',
      'L': 'icon-iconmaillist',
      'U': 'icon-iconman',
      'X': 'icon-iconman',
      'R': 'icon-icon_meeting'
    }

    const ContactList = function (path, options, $scope) {
      this.$scope = $scope

      this.start = 0
      this.searchStart = 0

      /** 每次只加载 50 个联系人 */
      /** load 50 items each time */
      this.limit = options.limit || 50

      /** 扩展所获取的部门 */
      /** a method for extending getting departments */
      this.extendDepartmentObj = options.extendDepartmentObj || null

      /** 扩展所获取的联系人 */
      /** a method for extending getting contacts */
      this.extendContactObj = options.extendContactObj || null

      /** 扩展搜索到的联系人 */
      /** a method for extending searching contacts */
      this.extendSearchObj = options.extendSearchObj || null

      this.cache = {
        addressList: {},
        contactList: {},
        searchList: {}
      }

      this.getDepartmentList(path)
      this.getContactList(path)

      /** init scope */
      $scope.search = {}
      $scope.hideListMore = true
      $scope.hideSearchMore = true
    }

    ContactList.prototype.clearContactListCondition = function () {
      this.start = 0
      this.$scope.contactList = []
    }

    ContactList.prototype.clearContactSearchCondition = function () {
      this.searchStart = 0
      this.$scope.searchList = []
      this.$scope.searchShowList = []
    }

    /**
     * 获取部门列表
     * get the list of departments
     * @param dn
     */
    ContactList.prototype.getDepartmentList = function (dn) {
      const self = this
      const $scope = self.$scope

      const initDepartmentInfo = function (list) {
        list.forEach(function (obj) {
          self.extendDepartmentObj && self.extendDepartmentObj(obj)
        })

        // 组织id
        $scope.orgId = list.id
        const str = location.hash.substring(19).match(/^\/\w*\//)
        // 此处为防止深层的部门id替换组织id
        if (str && str != '//' && $scope.orgId) {
          $scope.orgId = str[0].split('/')[1]
        }

        /** 非根目录且该部门下没有子部门 */
        /** not root and has no departments */
        if (!list.hasOwnProperty('ou') && dn !== '') {
          $scope.noAddress = true
        }

        $scope.orgName = list.name
        $scope.showBack = dn !== ''
      }

      $scope.isLoading = true
      $scope.noAddress = false

      const cacheList = self.cache.addressList[dn]
      if (cacheList) {
        $scope.addressList = cacheList
        initDepartmentInfo(cacheList)
        $scope.isLoading = false
      } else {
        contactListService.getAddress({
          attrIds: ['name', 'email'],
          dn
        }).then(function (data) {
          // 根据返回对象的差别，赋予$scope.addressList值
          if (data.code === 'S_OK' && data.var) {
            /** dn 为空则为根目录 */
            /** it is root when dn is empty */
            $scope.addressList = data.var.ou ? data.var.ou : (dn === '' ? data.var : [])
            self.cache.addressList[dn] = $scope.addressList
            self.cache.addressList[dn].id = data.var.id
            self.cache.addressList[dn].name = data.var.name
            $scope.addressList.forEach(function(address) {
              address.type = 'dept'
            })
            initDepartmentInfo($scope.addressList)
          }
        }, function (msg) {
          console.log(msg)
        }).finally(function () {
          $scope.isLoading = false
        })
      }
    }

    /**
     * 获取联系人列表
     * get the list of contacts
     * @param dn
     */
    ContactList.prototype.getContactList = function (dn) {
      const self = this
      const $scope = self.$scope

      const initContactInfo = function (contactList, total) {
        contactList.forEach(function (obj) {
          self.extendContactObj && self.extendContactObj(obj)
        })

        self.start = self.start + self.limit
        $scope.moreListData = (contactList.length < total)
        // 在部门列表中如果没有部门就显示没有的提示，此处若存在联系人则隐藏提示;如果全为部门亦隐藏“没有更多联系人了”提示
        $scope.hideListMore = !contactList.length
      }

      if (dn !== '') {
        $scope.isLoading = true

        const cacheList = self.cache.contactList[dn]
        if (cacheList && cacheList[self.start]) {
          $scope.contactList = $scope.contactList.concat(cacheList[self.start])
          initContactInfo($scope.contactList, cacheList.total)
          $scope.isLoading = false

          $ionicScrollDelegate.resize()
        } else {
          /** 当当前路径没有任何缓存时才清空 */
          /** clear all only when there is no any cache for the path */
          if (!cacheList) {
            self.clearContactListCondition()
          }

          contactListService.getContact({
            dn: dn,
            returnAttrs: ['email', '@id', 'true_name', '@ou', '@type'],
            start: self.start,
            limit: self.limit
          }).then(function (data) {
            if (data.code === 'S_OK' && data.var) {
              data.var.forEach(function (obj) {
                avatarType[obj['@type']] && (obj.avatar = avatarType[obj['@type']])
              })

              $scope.contactList = $scope.contactList.concat(data.var)
              self.cache.contactList[dn] = self.cache.contactList[dn] || {}
              self.cache.contactList[dn].total = data.total
              self.cache.contactList[dn][self.start] = data.var

              initContactInfo($scope.contactList, data.total)
            }
          }, function (msg) {
            console.log(msg)
          }).finally(function () {
            $scope.isLoading = false
            $scope.$broadcast('scroll.infiniteScrollComplete')
            $ionicScrollDelegate.resize()
          })
        }
      } else {
        /** 根目录没有联系人 */
        /** there is no contacts for root */
        $scope.hideListMore = true
      }
    }

    /**
     * 搜索所有类型的联系人
     * @param dn
     * @param keyword
     * @param extralMethod // 外部函数，这里主要用于搜索个人通讯录的联系人
     */
    ContactList.prototype.searchContact = function (dn, keyword, extralMethod) {
      const self = this
      const $scope = self.$scope

      const showSearch = function (list) {
        // 对传入的搜索结果列表项增加高亮字段, 若是个人通讯录的联系人则不需要
        list.forEach(function (obj) {
          if (!obj.hasOwnProperty('FN')) {
            self.extendSearchObj && self.extendSearchObj(obj)
          }
        })

        $scope.searchShowList = $scope.searchShowList.concat(list.slice(self.searchStart, self.searchStart + self.limit))
        self.searchStart += self.limit
        $scope.moreSearchData = ($scope.searchShowList.length < list.length)
        $scope.hideSearchMore = !$scope.searchShowList.length
        $scope.noResultFound = !$scope.searchShowList.length
        $scope.noResultFound && ($scope.notFoundKeyword = keyword)
      }

      $scope.isLoading = true
      const cacheList = self.cache.searchList[dn]
      if (cacheList && cacheList[keyword]) {
        showSearch(cacheList[keyword])
        $scope.isLoading = false

        $ionicScrollDelegate.resize()
      } else {
        /** clear all */
        self.clearContactSearchCondition()
        // 如果处于写信界面的选择联系人界面里的个人通讯录搜索的话只进行个人通讯录的搜索
        if ($scope.showGroupMemberList || $scope.showGroupList) {
          extralMethod(keyword).then(function(PabSearchList) {
            $scope.searchList = PabSearchList
            self.cache.searchList[dn] = self.cache.searchList[dn] || {}
            self.cache.searchList[dn][keyword] = $scope.searchList
            showSearch($scope.searchList)
          }, function(PabSearchList) {
            $scope.searchList = PabSearchList
            self.cache.searchList[dn] = self.cache.searchList[dn] || {}
            self.cache.searchList[dn][keyword] = $scope.searchList
            showSearch($scope.searchList)
          }).finally(function() {
            $scope.isLoading = false
          })
        } else {
          contactListService.searchContact({
            '@type': 'U,L,X,D,R',
            dn: dn,
            attrIds: ['m', '@id', '@type', 'security_level', 'location'],
            enableVirtualUserAC: true,
            enableAliasAC: true,
            enableNickNameAC: true,
            matchDuty: false,
            returnTotalVal: true,
            uniqueContacts: false,
            keyword: keyword,
            limit: 200,
            useCache: true
          }).then(function (data) {
            if (data.code == 'S_OK' && data.var) {
              $scope.searchList = data.var
              $scope.searchList.forEach(function (obj) {
                obj.showType = 'oab'
                avatarType[obj['@type']] && (obj.avatar = avatarType[obj['@type']])
                // 对组织通讯录筛选与关键词相匹配的别名账号
                obj['alias_email'] = $utils.$py.filterAliasEmail(obj, keyword)
              })
              // 若是通讯录首页的搜索则需要再加上对个人通讯录的搜索，然后将结果并入搜索结果的列表中
              if (!dn && extralMethod) {
                extralMethod(keyword).then(function(PabSearchList) {
                  $scope.searchList = $scope.searchList.concat(PabSearchList)
                  self.cache.searchList[dn] = self.cache.searchList[dn] || {}
                  self.cache.searchList[dn][keyword] = $scope.searchList
                  showSearch($scope.searchList)
                }, function(PabSearchList) {
                  $scope.searchList = $scope.searchList.concat(PabSearchList)
                  self.cache.searchList[dn] = self.cache.searchList[dn] || {}
                  self.cache.searchList[dn][keyword] = $scope.searchList
                  showSearch($scope.searchList)
                })
              } else {
                self.cache.searchList[dn] = self.cache.searchList[dn] || {}
                self.cache.searchList[dn][keyword] = $scope.searchList
                showSearch($scope.searchList)
              }
            }
          }).finally(function () {
            $scope.isLoading = false
          })
        }
      }
    }

    return ContactList
  }
]



// WEBPACK FOOTER //
// ./src/js/addressbook/organizational/contact/contactListMixin.js